import { Game, School, Scores, User, Quiz, Settings } from '/src/store'
import { Network } from '@capacitor/network'
import ApiService from '@/services/ApiService.js'

export default {
  /**
   * Set up network state listener to trigger sync on reconnection.
   * @return {Promise<void>}
   */
  async init () {
    Network.addListener('networkStatusChange', async (status) => {
      if (status.connected && User.getUser()) {
        // Sync user states if dirty
        await Promise.all([Game, School, Scores, Quiz]
          .map(s => s.sync()))
      }
    })

    const { connected } = await Network.getStatus()

    if (connected && User.getUser()) {
      await Promise.all([Game, School, Scores, Quiz]
        .map(s => s.sync()))
    }
  },

  /**
   * Upload dirty data
   * @param user
   * @return {Promise<void>}
   */
  async sync (user) {
    // Sync or update local data
    if (user.is_new_user === '1' || user.is_new_user === true || user.is_new_user === 1) {
      // console.log('AuthUserStateService.sync: will sync storages....')
      // Push local data to server for new users or
      // if was already authenticated but missing FB auth
      await Promise.all([
        Scores.sync(),
        Game.sync(),
        School.sync(),
        this.updateUserSettings(user)
      ])
    } else {
      // Overwrite local storage data from server for returning user. Will not consider dirty state.
      // console.log('AuthUserStateService.sync: will reset storages....')
      await Promise.all([
        Scores.reset(user),
        Game.reset({
          questions: user.seen_game_questions
        }),
        School.reset({
          topics: user.seen_topics,
          topic_pages: user.seen_topic_pages,
          school_questions: user.seen_school_questions
        }),
        Quiz.reset()
      ])
    }
  },

  /**
   * Update user settings, such as onboarding status.
   * TODO Make generic
   * @param user
   * @returns {Promise<*>}
   */
  async updateUserSettings (user) {
    // Push anon user settings
    const seenTutorials = Settings.getParam('seenTutorials', false)

    if (seenTutorials && !user.onboarding) {
      try {
        const { data } = await ApiService.updateUserSettings(user.id, { onboarding: true })

        // modify the local user object
        user.onboarding = data.onboarding
      } catch (e) {
        console.error('Failed to update user settings', e)
      }
    }

    return user
  },

  isDirty () {
    return [Game, School, Scores, Quiz]
      .some(store => store.isDirty())
  },

  async reset () {
    return Promise.all([
      Game.reset(),
      School.reset(),
      Scores.reset(),
      Quiz.reset()
    ])
  }
}
